var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        {
          staticClass: "mb-0 trafficking-type",
          staticStyle: { border: "none" }
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c("h4", [_vm._v("Type of Trafficking & Exploitation")]),
                  _vm._v(" "),
                  _c("p", { staticStyle: { "font-style": "italic" } }, [
                    _vm._v(
                      "\n                    Are you updating victim status for sex trafficking & exploitation,\n                    labor trafficking & exploitation or other type of exploitation?\n                    Select an option below.\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-form-select", {
                    attrs: {
                      size: "lg",
                      options: _vm.traffickingTypes,
                      id: "b_type_of_trafficking"
                    },
                    model: {
                      value: _vm.victimInfo.b_type_of_trafficking,
                      callback: function($$v) {
                        _vm.$set(_vm.victimInfo, "b_type_of_trafficking", $$v)
                      },
                      expression: "victimInfo.b_type_of_trafficking"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _vm.shouldShowMDTStatus
            ? _c(
                "b-row",
                {
                  staticClass: "mb-0 mdt-status",
                  staticStyle: { border: "none" }
                },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c("h4", [
                        _vm._v(
                          "Has the Investigative MDT Made a Determination?"
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", { staticStyle: { "font-style": "italic" } }, [
                        _vm._v(
                          "\n                    Please select an option, even if the investigative MDT team has not made a decision, or the decision is pending.\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        attrs: {
                          size: "lg",
                          options: _vm.mdtStatusOptions,
                          id: "b_mdt_status"
                        },
                        model: {
                          value: _vm.victimInfo.b_mdt_status,
                          callback: function($$v) {
                            _vm.$set(_vm.victimInfo, "b_mdt_status", $$v)
                          },
                          expression: "victimInfo.b_mdt_status"
                        }
                      }),
                      _vm._v(" "),
                      _vm.victimInfo.b_mdt_status === "Yes"
                        ? _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2 mt-4",
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "Investigative MDT Determination Date",
                                "label-for": "b_mdt_confirmed_date",
                                horizontal: false
                              }
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "mb-2",
                                  staticStyle: { "font-style": "italic" }
                                },
                                [
                                  _vm._v(
                                    "\n                        Please select the date the Investigative MDT made their determination on the case.\n                    "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("datepicker", {
                                attrs: {
                                  "input-class":
                                    "form-control-lg datepicker-input",
                                  "initial-view": "year",
                                  id: "b_mdt_confirmed_date",
                                  placeholder: "Select Date",
                                  format: this.$dateFormatter,
                                  "disabled-dates": { from: new Date() }
                                },
                                model: {
                                  value: _vm.victimInfo.b_mdt_confirmed_date,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.victimInfo,
                                      "b_mdt_confirmed_date",
                                      $$v
                                    )
                                  },
                                  expression: "victimInfo.b_mdt_confirmed_date"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.victimInfo.b_mdt_status === "Pending"
                        ? _c("h5", { staticClass: "mt-2" }, [
                            _vm._v(
                              "\n                    Case is eligible for Investigate MDT, but victim status determination is pending.\n                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.victimInfo.b_mdt_status === "Pending"
                        ? _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2 mt-4",
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label:
                                  "Case Eligibility for Investigative MDT Confirmation Date",
                                "label-for": "b_mdt_decided_date",
                                horizontal: false
                              }
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "mb-2",
                                  staticStyle: { "font-style": "italic" }
                                },
                                [
                                  _vm._v(
                                    "\n                        Please select the date the case was decided eligible for Investigative MDT determination.\n                    "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("datepicker", {
                                attrs: {
                                  "input-class":
                                    "form-control-lg datepicker-input",
                                  "initial-view": "year",
                                  id: "b_mdt_decided_date",
                                  placeholder: "Select Date",
                                  format: this.$dateFormatter,
                                  "disabled-dates": { from: new Date() }
                                },
                                model: {
                                  value: _vm.victimInfo.b_mdt_decided_date,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.victimInfo,
                                      "b_mdt_decided_date",
                                      $$v
                                    )
                                  },
                                  expression: "victimInfo.b_mdt_decided_date"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.victimInfo.b_mdt_status === "No"
                        ? _c(
                            "b-form-group",
                            {
                              staticClass: "mb-2 mt-4",
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label:
                                  "Please select the reason why the Investigative MDT has not made a decision.",
                                "label-for": "b_mdt_rejected_reason",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  size: "lg",
                                  options: _vm.mdtRejectedReasonOptions,
                                  id: "b_mdt_rejected_reason"
                                },
                                model: {
                                  value: _vm.victimInfo.b_mdt_rejected_reason,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.victimInfo,
                                      "b_mdt_rejected_reason",
                                      $$v
                                    )
                                  },
                                  expression: "victimInfo.b_mdt_rejected_reason"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.victimInfo.b_mdt_status === "No"
                        ? _c(
                            "b-form-group",
                            {
                              staticClass: "pb-2 pl-1",
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "Comments",
                                "label-for": "b_mdt_rejected_comment",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-textarea", {
                                staticClass: "mt-3",
                                attrs: {
                                  maxlength: 255,
                                  rows: 3,
                                  placeholder: "Enter Comments",
                                  name: "b_mdt_rejected_comment"
                                },
                                model: {
                                  value: _vm.victimInfo.b_mdt_rejected_comment,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.victimInfo,
                                      "b_mdt_rejected_comment",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "victimInfo.b_mdt_rejected_comment"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.shouldShowVictimStatus
            ? _c(
                "b-row",
                {
                  staticClass: "mb-0 victim-status",
                  staticStyle: { border: "none" }
                },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "pb-2 pl-1",
                          attrs: {
                            "label-size": "lg",
                            "label-class": "addpersonlabel",
                            label: "Victim Status",
                            "label-for": "b_confirmed",
                            horizontal: false
                          }
                        },
                        [
                          _c("info-icon", {
                            staticStyle: {
                              position: "relative",
                              top: "-49px",
                              "margin-left": "135px",
                              cursor: "pointer"
                            },
                            on: { click: _vm.handleVictimStatusModal }
                          }),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "margin-top": "-47px",
                                "padding-bottom": "20px",
                                "font-style": "italic",
                                color: "gray"
                              }
                            },
                            [
                              _vm._v(
                                "\n                            Select an option below. Click the information icon for detailed definitions.\n                        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("b-form-select", {
                            staticStyle: { "margin-top": "-20px" },
                            attrs: {
                              size: "lg",
                              options: _vm.victimStatusOptions,
                              id: "b_confirmed"
                            },
                            model: {
                              value: _vm.victimInfo.b_confirmed,
                              callback: function($$v) {
                                _vm.$set(_vm.victimInfo, "b_confirmed", $$v)
                              },
                              expression: "victimInfo.b_confirmed"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.victimInfo.b_confirmed === "Other" &&
                      (_vm.isOrgManager || _vm.isCareCoordinator)
                        ? _c(
                            "b-form-group",
                            {
                              staticClass: "pb-2 pl-1",
                              attrs: { "label-size": "lg", label: "Why?" }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  size: "lg",
                                  options: _vm.victimStatusOtherOptions,
                                  id: "b_confirmed_otherText"
                                },
                                model: {
                                  value: _vm.victimInfo.b_confirmed_otherText,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.victimInfo,
                                      "b_confirmed_otherText",
                                      $$v
                                    )
                                  },
                                  expression: "victimInfo.b_confirmed_otherText"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isAtRiskOrUnknown
                        ? _c(
                            "b-form-group",
                            {
                              staticClass: "pb-2 pl-1",
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "Comments",
                                "label-for": "b_confirmed_comment",
                                horizontal: false
                              }
                            },
                            [
                              _c("b-form-textarea", {
                                staticClass: "mt-3",
                                attrs: {
                                  maxlength: 255,
                                  rows: 3,
                                  placeholder: "Enter Comment",
                                  name: "b_confirmed_comment"
                                },
                                model: {
                                  value: _vm.victimInfo.b_confirmed_comment,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.victimInfo,
                                      "b_confirmed_comment",
                                      $$v
                                    )
                                  },
                                  expression: "victimInfo.b_confirmed_comment"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.victimInfo.b_confirmed === "Yes"
                        ? _c(
                            "div",
                            {
                              staticClass: "victim-confirmation",
                              staticStyle: { "padding-top": "9px" }
                            },
                            [
                              _c("h4", [_vm._v("Victim Confirmation")]),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-size": "lg",
                                    "label-class": "addpersonlabel",
                                    label:
                                      "If the person is a confirmed victim of trafficking, how were they confirmed? (Select all that apply)",
                                    "label-for": "b_confirmation_source",
                                    horizontal: false
                                  }
                                },
                                [
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      attrs: {
                                        switch: "",
                                        size: "lg",
                                        "label-size": "lg",
                                        "label-class": "addpersonlabel",
                                        name: "check-button-confirm-LE"
                                      },
                                      model: {
                                        value: _vm.victimInfo.b_confirmation_LE,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.victimInfo,
                                            "b_confirmation_LE",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "victimInfo.b_confirmation_LE"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Confirmed by Law Enforcement\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "transition",
                                    { attrs: { name: "form-fade" } },
                                    [
                                      _vm.victimInfo.b_confirmation_LE
                                        ? _c(
                                            "div",
                                            { staticClass: "sub-group" },
                                            [
                                              _c("br"),
                                              _vm._v(" "),
                                              _c(
                                                "b-card",
                                                {
                                                  staticStyle: {
                                                    border: "none"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "b-row",
                                                    [
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: {
                                                            md: "6",
                                                            sm: "6"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                "label-class":
                                                                  "addpersonlabel",
                                                                label:
                                                                  "Confirmation Date",
                                                                "label-for":
                                                                  "b_confirmation_LE_date",
                                                                horizontal: false
                                                              }
                                                            },
                                                            [
                                                              _c("datepicker", {
                                                                attrs: {
                                                                  "input-class":
                                                                    "form-control-lg",
                                                                  "initial-view":
                                                                    "year",
                                                                  id:
                                                                    "b_confirmation_LE_date",
                                                                  placeholder:
                                                                    "Select Date",
                                                                  format: this
                                                                    .$dateFormatter,
                                                                  "disabled-dates": {
                                                                    from: new Date()
                                                                  }
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .victimInfo
                                                                      .b_confirmation_LE_date,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.victimInfo,
                                                                      "b_confirmation_LE_date",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "victimInfo.b_confirmation_LE_date"
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: {
                                                            md: "6",
                                                            sm: "12"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                label:
                                                                  "Confirmation Comments",
                                                                "label-class":
                                                                  "addpersonlabel",
                                                                "label-for":
                                                                  "b_confirmation_LE_comment"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-textarea",
                                                                {
                                                                  attrs: {
                                                                    rows: "5",
                                                                    placeholder:
                                                                      "Enter Comment",
                                                                    name:
                                                                      "b_confirmation_LE_comment"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .victimInfo
                                                                        .b_confirmation_LE_comment,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.victimInfo,
                                                                        "b_confirmation_LE_comment",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "victimInfo.b_confirmation_LE_comment"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      attrs: {
                                        switch: "",
                                        size: "lg",
                                        "label-size": "lg",
                                        "label-class": "addpersonlabel",
                                        name: "check-button-confirm-Victim"
                                      },
                                      model: {
                                        value:
                                          _vm.victimInfo.b_confirmation_Victim,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.victimInfo,
                                            "b_confirmation_Victim",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "victimInfo.b_confirmation_Victim"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Confirmed by Victim Outcry\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "transition",
                                    { attrs: { name: "form-fade" } },
                                    [
                                      _vm.victimInfo.b_confirmation_Victim
                                        ? _c(
                                            "div",
                                            { staticClass: "sub-group" },
                                            [
                                              _c("br"),
                                              _vm._v(" "),
                                              _c(
                                                "b-card",
                                                {
                                                  staticStyle: {
                                                    border: "none"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "b-row",
                                                    [
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: {
                                                            md: "6",
                                                            sm: "6"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                "label-class":
                                                                  "addpersonlabel",
                                                                label:
                                                                  "Confirmation Date",
                                                                "label-for":
                                                                  "b_confirmation_Victim_date",
                                                                horizontal: false
                                                              }
                                                            },
                                                            [
                                                              _c("datepicker", {
                                                                attrs: {
                                                                  "input-class":
                                                                    "form-control-lg",
                                                                  "initial-view":
                                                                    "year",
                                                                  id:
                                                                    "b_confirmation_Victim_date",
                                                                  placeholder:
                                                                    "Select Date",
                                                                  format: this
                                                                    .$dateFormatter,
                                                                  "disabled-dates": {
                                                                    from: new Date()
                                                                  }
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .victimInfo
                                                                      .b_confirmation_Victim_date,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.victimInfo,
                                                                      "b_confirmation_Victim_date",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "victimInfo.b_confirmation_Victim_date"
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: {
                                                            md: "6",
                                                            sm: "12"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                label:
                                                                  "Confirmation Comments",
                                                                "label-class":
                                                                  "addpersonlabel",
                                                                "label-for":
                                                                  "b_confirmation_Victim_comment"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-textarea",
                                                                {
                                                                  attrs: {
                                                                    rows: "5",
                                                                    placeholder:
                                                                      "Enter Comment",
                                                                    name:
                                                                      "b_confirmation_Victim_comment"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .victimInfo
                                                                        .b_confirmation_Victim_comment,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.victimInfo,
                                                                        "b_confirmation_Victim_comment",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "victimInfo.b_confirmation_Victim_comment"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      attrs: {
                                        switch: "",
                                        size: "lg",
                                        "label-size": "lg",
                                        "label-class": "addpersonlabel",
                                        name: "check-button-confirm-CPS"
                                      },
                                      model: {
                                        value:
                                          _vm.victimInfo.b_confirmation_CPS,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.victimInfo,
                                            "b_confirmation_CPS",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "victimInfo.b_confirmation_CPS"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Confirmed by Child Protective Services\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "transition",
                                    { attrs: { name: "form-fade" } },
                                    [
                                      _vm.victimInfo.b_confirmation_CPS
                                        ? _c(
                                            "div",
                                            { staticClass: "sub-group" },
                                            [
                                              _c("br"),
                                              _vm._v(" "),
                                              _c(
                                                "b-card",
                                                {
                                                  staticStyle: {
                                                    border: "none"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "b-row",
                                                    [
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: {
                                                            md: "6",
                                                            sm: "6"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                "label-class":
                                                                  "addpersonlabel",
                                                                label:
                                                                  "Confirmation Date",
                                                                "label-for":
                                                                  "b_confirmation_CPS_date",
                                                                horizontal: false
                                                              }
                                                            },
                                                            [
                                                              _c("datepicker", {
                                                                attrs: {
                                                                  "input-class":
                                                                    "form-control-lg",
                                                                  "initial-view":
                                                                    "year",
                                                                  id:
                                                                    "b_confirmation_CPS_date",
                                                                  placeholder:
                                                                    "Select Date",
                                                                  format: this
                                                                    .$dateFormatter,
                                                                  "disabled-dates": {
                                                                    from: new Date()
                                                                  }
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .victimInfo
                                                                      .b_confirmation_CPS_date,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.victimInfo,
                                                                      "b_confirmation_CPS_date",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "victimInfo.b_confirmation_CPS_date"
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: {
                                                            md: "6",
                                                            sm: "12"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                label:
                                                                  "Confirmation Comments",
                                                                "label-class":
                                                                  "addpersonlabel",
                                                                "label-for":
                                                                  "b_confirmation_CPS_comment"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-textarea",
                                                                {
                                                                  attrs: {
                                                                    rows: "5",
                                                                    placeholder:
                                                                      "Enter Comment",
                                                                    name:
                                                                      "b_confirmation_CPS_comment"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .victimInfo
                                                                        .b_confirmation_CPS_comment,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.victimInfo,
                                                                        "b_confirmation_CPS_comment",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "victimInfo.b_confirmation_CPS_comment"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      attrs: {
                                        switch: "",
                                        size: "lg",
                                        "label-size": "lg",
                                        "label-class": "addpersonlabel",
                                        name: "check-button-confirm-Expert"
                                      },
                                      model: {
                                        value:
                                          _vm.victimInfo.b_confirmation_Expert,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.victimInfo,
                                            "b_confirmation_Expert",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "victimInfo.b_confirmation_Expert"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                Confirmed by Expert Assessment (e.g., Forensic Interview)\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "transition",
                                    { attrs: { name: "form-fade" } },
                                    [
                                      _vm.victimInfo.b_confirmation_Expert
                                        ? _c(
                                            "div",
                                            { staticClass: "sub-group" },
                                            [
                                              _c("br"),
                                              _vm._v(" "),
                                              _c(
                                                "b-card",
                                                {
                                                  staticStyle: {
                                                    border: "none"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "b-row",
                                                    [
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: {
                                                            md: "6",
                                                            sm: "6"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                "label-class":
                                                                  "addpersonlabel",
                                                                label:
                                                                  "Confirmation Date",
                                                                "label-for":
                                                                  "b_confirmation_Expert_date",
                                                                horizontal: false
                                                              }
                                                            },
                                                            [
                                                              _c("datepicker", {
                                                                attrs: {
                                                                  "input-class":
                                                                    "form-control-lg",
                                                                  "initial-view":
                                                                    "year",
                                                                  id:
                                                                    "b_confirmation_Expert_date",
                                                                  placeholder:
                                                                    "Select Date",
                                                                  format: this
                                                                    .$dateFormatter,
                                                                  "disabled-dates": {
                                                                    from: new Date()
                                                                  }
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .victimInfo
                                                                      .b_confirmation_Expert_date,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.victimInfo,
                                                                      "b_confirmation_Expert_date",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "victimInfo.b_confirmation_Expert_date"
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: {
                                                            md: "6",
                                                            sm: "12"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                label:
                                                                  "Confirmation Comments",
                                                                "label-class":
                                                                  "addpersonlabel",
                                                                "label-for":
                                                                  "b_confirmation_Expert_comment"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-textarea",
                                                                {
                                                                  attrs: {
                                                                    rows: "5",
                                                                    placeholder:
                                                                      "Enter Comment",
                                                                    name:
                                                                      "b_confirmation_Expert_comment"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .victimInfo
                                                                        .b_confirmation_Expert_comment,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.victimInfo,
                                                                        "b_confirmation_Expert_comment",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "victimInfo.b_confirmation_Expert_comment"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      attrs: {
                                        switch: "",
                                        size: "lg",
                                        "label-size": "lg",
                                        "label-class": "addpersonlabel",
                                        name: "check-button-confirm-Other"
                                      },
                                      model: {
                                        value:
                                          _vm.victimInfo.b_confirmation_Other,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.victimInfo,
                                            "b_confirmation_Other",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "victimInfo.b_confirmation_Other"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                Confirmed by other means\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "transition",
                                    { attrs: { name: "form-fade" } },
                                    [
                                      _vm.victimInfo.b_confirmation_Other
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "sub-group marginB0"
                                            },
                                            [
                                              _c("br"),
                                              _vm._v(" "),
                                              _c(
                                                "b-card",
                                                {
                                                  staticClass:
                                                    "noBoxShadow marginB0"
                                                },
                                                [
                                                  _c(
                                                    "b-row",
                                                    [
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: {
                                                            md: "6",
                                                            sm: "6"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                "label-class":
                                                                  "addpersonlabel",
                                                                label:
                                                                  "Confirmation Date",
                                                                "label-for":
                                                                  "b_confirmation_Other_date",
                                                                horizontal: false
                                                              }
                                                            },
                                                            [
                                                              _c("datepicker", {
                                                                attrs: {
                                                                  "input-class":
                                                                    "form-control-lg",
                                                                  "initial-view":
                                                                    "year",
                                                                  id:
                                                                    "b_confirmation_Other_date",
                                                                  placeholder:
                                                                    "Select Date",
                                                                  format: this
                                                                    .$dateFormatter,
                                                                  "disabled-dates": {
                                                                    from: new Date()
                                                                  }
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .victimInfo
                                                                      .b_confirmation_Other_date,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.victimInfo,
                                                                      "b_confirmation_Other_date",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "victimInfo.b_confirmation_Other_date"
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: {
                                                            md: "6",
                                                            sm: "12"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              staticClass:
                                                                "marginB0",
                                                              attrs: {
                                                                label:
                                                                  "Confirmation Comments",
                                                                "label-class":
                                                                  "addpersonlabel",
                                                                "label-for":
                                                                  "b_confirmation_Other_comment"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-textarea",
                                                                {
                                                                  attrs: {
                                                                    rows: "5",
                                                                    placeholder:
                                                                      "Enter Comment",
                                                                    name:
                                                                      "b_confirmation_Other_comment"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .victimInfo
                                                                        .b_confirmation_Other_comment,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.victimInfo,
                                                                        "b_confirmation_Other_comment",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "victimInfo.b_confirmation_Other_comment"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.shouldShowMeansOfTrafficking
            ? _c(
                "div",
                [
                  _c("br"),
                  _vm._v(" "),
                  _vm.isSexTrafficking
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c("h4", [
                                _vm._v(
                                  "Means of Sex Trafficking (select all that apply):"
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.sexTraffickingMeans, function(means) {
                                return _c(
                                  "b-form-group",
                                  {
                                    key: means.value,
                                    staticClass: "pb-2 pl-1",
                                    attrs: {
                                      "label-size": "lg",
                                      "label-class": "addpersonlabel",
                                      flush: ""
                                    }
                                  },
                                  [
                                    _c(
                                      "p-check",
                                      {
                                        staticClass:
                                          "p-success p-round h5 p-0 m-0 p-smooth p-plain",
                                        attrs: { large: "", color: "success" },
                                        model: {
                                          value:
                                            _vm.victimInfo["i_" + means.value],
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.victimInfo,
                                              "i_" + means.value,
                                              $$v
                                            )
                                          },
                                          expression:
                                            "victimInfo[`i_${means.value}`]"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(means.text) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    : _vm.isLaborTrafficking
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c("h4", [
                                _vm._v(
                                  "Means of Labor Trafficking (select all that apply):"
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.laborTraffickingMeans, function(
                                means
                              ) {
                                return _c(
                                  "b-form-group",
                                  {
                                    key: means.value,
                                    staticClass: "pb-2 pl-1",
                                    attrs: {
                                      "label-size": "lg",
                                      "label-class": "addpersonlabel",
                                      flush: ""
                                    }
                                  },
                                  [
                                    _c(
                                      "p-check",
                                      {
                                        staticClass:
                                          "p-success p-round h5 p-0 m-0 p-smooth p-plain",
                                        attrs: { large: "", color: "success" },
                                        model: {
                                          value:
                                            _vm.victimInfo["i_" + means.value],
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.victimInfo,
                                              "i_" + means.value,
                                              $$v
                                            )
                                          },
                                          expression:
                                            "victimInfo[`i_${means.value}`]"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(means.text) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              }),
                              _vm._v(" "),
                              _vm.isIndustryRelatedTrafficking
                                ? _c(
                                    "b-form-group",
                                    [
                                      _c("b-form-select", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        attrs: {
                                          size: "lg",
                                          id: "nested-industry",
                                          "data-vv-name": "traffickedIndustry",
                                          "data-vv-as": "Industry",
                                          placeholder:
                                            "Please select an option",
                                          options: _vm.industryRelatedOptions
                                        },
                                        model: {
                                          value:
                                            _vm.victimInfo
                                              .i_l_trafficked_industry,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.victimInfo,
                                              "i_l_trafficked_industry",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "victimInfo.i_l_trafficked_industry"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.inputValidationErrors.has(
                                                "traffickedIndustry"
                                              ),
                                              expression:
                                                "inputValidationErrors.has('traffickedIndustry')"
                                            }
                                          ],
                                          staticClass: "text-info"
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.inputValidationErrors.first(
                                                  "traffickedIndustry"
                                                )
                                              ) +
                                              "\n                        "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.victimInfo.i_l_trafficked_industry ===
                                      "Other"
                                        ? _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                "label-size": "lg",
                                                label: "Industry Description"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                attrs: {
                                                  size: "lg",
                                                  "data-vv-name": "Other",
                                                  "data-vv-as": "Other"
                                                },
                                                model: {
                                                  value:
                                                    _vm.victimInfo
                                                      .i_l_trafficked_industry_otherText,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.victimInfo,
                                                      "i_l_trafficked_industry_otherText",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "victimInfo.i_l_trafficked_industry_otherText"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.inputValidationErrors.has(
                                                        "i_l_trafficked_industry_otherText"
                                                      ),
                                                      expression:
                                                        "inputValidationErrors.has('i_l_trafficked_industry_otherText')"
                                                    }
                                                  ],
                                                  staticClass: "text-info"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.inputValidationErrors.first(
                                                        "i_l_trafficked_industry_otherText"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "Location of Trafficking Incident",
                                "label-for": "b_location_of_trafficking",
                                horizontal: false
                              }
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "margin-top": "-20px",
                                    "font-style": "italic",
                                    color: "gray"
                                  }
                                },
                                [
                                  _vm._v(
                                    "Select the location in which trafficking occurred."
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-form-select", {
                                attrs: {
                                  size: "lg",
                                  options: _vm.countyOrParishOptionsTrafficking,
                                  id: "b_location_of_trafficking"
                                },
                                model: {
                                  value:
                                    _vm.victimInfo.b_location_of_trafficking,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.victimInfo,
                                      "b_location_of_trafficking",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "victimInfo.b_location_of_trafficking"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.victimInfo.b_location_of_trafficking ===
                          "Multiple"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "lg",
                                        "label-class": "addpersonlabel",
                                        label:
                                          "Trafficking - Multiple (Primary)",
                                        "label-for":
                                          "b_location_of_trafficking_multiple_one",
                                        horizontal: false
                                      }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            "margin-top": "-20px",
                                            "font-style": "italic",
                                            color: "gray"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Select the primary location in which trafficking occurred."
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-select", {
                                        attrs: {
                                          size: "lg",
                                          options: _vm.countyOrParishOptions,
                                          id:
                                            "b_location_of_trafficking_multiple_one"
                                        },
                                        model: {
                                          value:
                                            _vm.victimInfo
                                              .b_location_of_trafficking_multiple_one,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.victimInfo,
                                              "b_location_of_trafficking_multiple_one",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "victimInfo.b_location_of_trafficking_multiple_one"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "lg",
                                        "label-class": "addpersonlabel",
                                        label:
                                          "Trafficking - Multiple (Secondary)",
                                        "label-for":
                                          "b_location_of_trafficking_multiple_two",
                                        horizontal: false
                                      }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            "margin-top": "-20px",
                                            "font-style": "italic",
                                            color: "gray"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Enter the secondary locations in which trafficking occurred."
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        attrs: {
                                          "data-vv-name":
                                            "victimInfo.b_location_of_trafficking_multiple_two",
                                          size: "lg",
                                          id:
                                            "b_location_of_trafficking_multiple_two"
                                        },
                                        model: {
                                          value:
                                            _vm.victimInfo
                                              .b_location_of_trafficking_multiple_two,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.victimInfo,
                                              "b_location_of_trafficking_multiple_two",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "victimInfo.b_location_of_trafficking_multiple_two"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.victimInfo.b_location_of_trafficking ===
                          "Out of State"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "lg",
                                        "label-class": "addpersonlabel",
                                        label: "Trafficking - Out of State",
                                        "label-for":
                                          "b_location_of_trafficking_out_state",
                                        horizontal: false
                                      }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            "margin-top": "-20px",
                                            "font-style": "italic",
                                            color: "gray"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Select the state in which trafficking occurred."
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-select", {
                                        attrs: {
                                          size: "lg",
                                          options: _vm.stateAndAbbrev,
                                          id:
                                            "b_location_of_trafficking_out_state"
                                        },
                                        model: {
                                          value:
                                            _vm.victimInfo
                                              .b_location_of_trafficking_out_state,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.victimInfo,
                                              "b_location_of_trafficking_out_state",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "victimInfo.b_location_of_trafficking_out_state"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "lg",
                                        "label-class": "addpersonlabel",
                                        label:
                                          "Trafficking - Out of State (City)",
                                        "label-for":
                                          "b_location_of_trafficking_out_state_city",
                                        horizontal: false
                                      }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            "margin-top": "-20px",
                                            "font-style": "italic",
                                            color: "gray"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Enter the city in which trafficking occurred."
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        attrs: {
                                          "data-vv-name":
                                            "victimInfo.b_location_of_trafficking_out_state_city",
                                          size: "lg",
                                          id:
                                            "b_location_of_trafficking_out_state_city"
                                        },
                                        model: {
                                          value:
                                            _vm.victimInfo
                                              .b_location_of_trafficking_out_state_city,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.victimInfo,
                                              "b_location_of_trafficking_out_state_city",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "victimInfo.b_location_of_trafficking_out_state_city"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.victimInfo.b_location_of_trafficking ===
                          "Out of Country"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "lg",
                                        "label-class": "addpersonlabel",
                                        label: "Trafficking - Out of Country",
                                        "label-for":
                                          "b_location_of_trafficking_out_country",
                                        horizontal: false
                                      }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            "margin-top": "-20px",
                                            "font-style": "italic",
                                            color: "gray"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Select the country in which trafficking occurred."
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-select", {
                                        attrs: {
                                          size: "lg",
                                          options: _vm.getNonUSCountries,
                                          id:
                                            "b_location_of_trafficking_out_country"
                                        },
                                        model: {
                                          value:
                                            _vm.victimInfo
                                              .b_location_of_trafficking_out_country,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.victimInfo,
                                              "b_location_of_trafficking_out_country",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "victimInfo.b_location_of_trafficking_out_country"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-size": "lg",
                                "label-class": "addpersonlabel",
                                label: "Location of Origin",
                                "label-for": "b_location_of_origin",
                                horizontal: false
                              }
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "margin-top": "-20px",
                                    "font-style": "italic",
                                    color: "gray"
                                  }
                                },
                                [
                                  _vm._v(
                                    "Select the location where the victim identifies as their principal, or home, location."
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-form-select", {
                                attrs: {
                                  size: "lg",
                                  options: _vm.countyOrParishOptionsOrigin,
                                  id: "b_location_of_origin"
                                },
                                model: {
                                  value: _vm.victimInfo.b_location_of_origin,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.victimInfo,
                                      "b_location_of_origin",
                                      $$v
                                    )
                                  },
                                  expression: "victimInfo.b_location_of_origin"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.victimInfo.b_location_of_origin === "Out of State"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "lg",
                                        "label-class": "addpersonlabel",
                                        label: "Origin - Out of State",
                                        "label-for":
                                          "b_location_of_origin_out_state",
                                        horizontal: false
                                      }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            "margin-top": "-20px",
                                            "font-style": "italic",
                                            color: "gray"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Select the state where the victim identifies as their principal, or home, location."
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-select", {
                                        attrs: {
                                          size: "lg",
                                          options: _vm.stateAndAbbrev,
                                          id: "b_location_of_origin_out_state"
                                        },
                                        model: {
                                          value:
                                            _vm.victimInfo
                                              .b_location_of_origin_out_state,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.victimInfo,
                                              "b_location_of_origin_out_state",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "victimInfo.b_location_of_origin_out_state"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "lg",
                                        "label-class": "addpersonlabel",
                                        label: "Origin - Out of State (City)",
                                        "label-for":
                                          "b_location_of_origin_out_state_city",
                                        horizontal: false
                                      }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            "margin-top": "-20px",
                                            "font-style": "italic",
                                            color: "gray"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Enter the city where the victim identifies as their principal, or home, location."
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        attrs: {
                                          "data-vv-name":
                                            "victimInfo.b_location_of_origin_out_state_city",
                                          size: "lg",
                                          id:
                                            "b_location_of_origin_out_state_city"
                                        },
                                        model: {
                                          value:
                                            _vm.victimInfo
                                              .b_location_of_origin_out_state_city,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.victimInfo,
                                              "b_location_of_origin_out_state_city",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "victimInfo.b_location_of_origin_out_state_city"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.victimInfo.b_location_of_origin ===
                          "Out of Country"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "lg",
                                        "label-class": "addpersonlabel",
                                        label: "Origin - Out of Country",
                                        "label-for":
                                          "b_location_of_origin_country",
                                        horizontal: false
                                      }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            "margin-top": "-20px",
                                            "font-style": "italic",
                                            color: "gray"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Select the country where the victim identifies as their principal, or home, location."
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-select", {
                                        attrs: {
                                          size: "lg",
                                          options: _vm.getNonUSCountries,
                                          id: "b_location_of_origin_country"
                                        },
                                        model: {
                                          value:
                                            _vm.victimInfo
                                              .b_location_of_origin_country,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.victimInfo,
                                              "b_location_of_origin_country",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "victimInfo.b_location_of_origin_country"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.showVictimStatusModal
        ? _c(
            "b-modal",
            {
              attrs: {
                scrollable: "",
                title: "Victim Status",
                visible: _vm.showVictimStatusModal,
                "header-bg-variant": "success",
                "header-text-variant": "light",
                size: "md",
                centered: "",
                id: "modal",
                "ok-only": ""
              },
              on: { ok: _vm.handleVictimStatusModal },
              scopedSlots: _vm._u(
                [
                  {
                    key: "modal-header-close",
                    fn: function() {
                      return [_c("h4", [_vm._v("X")])]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                2419867756
              )
            },
            [
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.stateName === "LA"
                      ? 'A trafficking event is considered "confirmed" when evidence supports the conclusion that the individual is a victim of human trafficking, as defined in La. RS 14:46.2, La. RS 14:46.3, or the federal Trafficking Victims Protection Act (TVPA). The supporting evidence must be more than just an allegation or suspicion.'
                      : 'A trafficking event is considered "confirmed" when evidence supports the conclusion that the individual is a victim of human trafficking, as defined in the federal Trafficking Victims Protection Act (TVPA). The supporting evidence must be more than just an allegation or suspicion.'
                  )
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  'A trafficking event is considered "suspected" when specific information regarding the individual and the surrounding circumstances creates a reasonable belief that the individual is a victim of human trafficking. The presence of one or more risk factors does not necessarily equate to a "suspected" case of trafficking.'
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n            An individual is considered “at-risk” for human trafficking when the individual displays one or more risk factors of human trafficking.\n            This includes but is not limited to: system-involvement, past history of abuse, homelessness or frequent runaway behavior,\n            substance abuse disorder, among other factors. The presence of one or more risk factors for human trafficking, by itself,\n            does not equate to a confirmed or suspected case of human trafficking.\n        "
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n            An individual’s victim status is considered “unknown” when the agency lacks sufficient information to classify the individual as confirmed,\n            suspected, or at-risk for human trafficking at this time. Upon gaining additional information on the individual,\n            the individual’s victim status should be updated.\n        "
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _c("b", [_vm._v("Note")]),
                _vm._v(
                  ": Most screening tools are not diagnostic tools. If a screening for human trafficking has been conducted on an individual, the results of the screening may not be sufficient alone to determine victim status."
                )
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-095e92f7", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-095e92f7","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/PersonVictimInfoForm.vue
// module id = 1715
// module chunks = 0